import {
  mapState,
  mapMutations
} from 'vuex'
import Typecash from '../components/payment/TypeCach'
import Typepromptpay from '../components/payment/TypePromptpay'
import Typewallet from '../components/payment/TypeWallet'
import Typecredit from '../components/payment/TypeCredit'
import RefurdPad from '../components/modal/refundpad'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import api from '../service/services'
import swal from 'sweetalert2'

export default {
  components: {
    Loading,
    Typecash,
    Typepromptpay,
    Typewallet,
    Typecredit,
    RefurdPad
  },
  data() {
    return {
      steppull: 0,
      title: 'เมนู',
      qrcode: '',
      itemImage: require('../assets/no_select.png'),
      orderName: 'Select Item',
      step: 0,
      channel: null,
      chceck_genqr: 0,
      saleTypeText: '',
      t: '',
      sp: ''
    }
  },
  computed: {
    ...mapState([
      'lang',
      'AmountPayment',
      'UUID',
      'txn_id',
      'accessToken',
      'PaymentType',
      'IDWallet',
      'SaleID',
      'sale_subs',
      'page_status',
      'config',
    ]),
    ...mapMutations(['onMessageWs', 'clearState'])
  },
  methods: {
    back() {
      this.Soundclick()
      clearInterval(this.t)
      this.$store.commit('clearPulling')
      this.$store.state.timeOut = 120
      if (this.$store.state.AmountPayment > 0) {
        $('#Refurd').modal({ backdrop: "static" })
      } else {
        this.$socket.sendObj({
          command: 'receive_close'
        })
        this.$socket.sendObj({
          command: 'edc_cancel'
        })

        if (this.$store.state.page_status == 1) {
          this.$router.push({
            name: 'Main'
          })
          this.$store.state.page_status = 0
          return
        }
        if (this.$store.state.page_status == 2) {
          this.$router.push({
            name: 'shopping'
          })
          this.$store.state.page_status = 0
          setTimeout(() => {
          this.$store.state.isLoading
          },2000)
          return
        }
        this.$router.go(-1)
      }
    },
    deleyTime() {
      this.t = setInterval(() => {
        this.checkAmount()
        if (this.$store.state.timeOut > 0) {
          this.$store.state.timeOut--
        } else {
          clearInterval(this.t)
          if (this.$store.state.AmountPayment > 0){
            swal.fire({
              title: 'TimeOut',
              text: "ต้องการชำระเงินต่อไปหรือไม่",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'OK !'
            }).then((result) => {
              if (result.value) {
                this.$store.state.timeOut = 120
                this.steppull = 0
                this.$socket.sendObj({
                  command: 'receive_open'
                })
                this.deleyTime()
              } else {
                this.back()
              }
            })
          } else {
            this.back()
          }
        }
      }, 1000)
    },
    checkSaleType() {
      switch (this.$store.state.SaleID) {
        case 1:
          this.saleTypeText = 'Deposit'
          if (this.$store.state.sale_subs[0].image) {
            this.itemImage = this.$store.state.sale_subs[0].image
          }
          break
        case 2:
          this.saleTypeText = 'shopping'
          break
        case 3:
          this.saleTypeText = 'SCAN QRCODE'
          break
        case 4:
          this.saleTypeText = 'Quick Pay'
          if (this.$store.state.sale_subs[0].image) {
            this.itemImage = this.$store.state.sale_subs[0].image
          }
          break
        case 5:
          this.saleTypeText = 'Mobile app payment'
          if (this.$store.state.sale_subs[0].image) {
            this.itemImage = this.$store.state.sale_subs[0].image
          }
          break
        case 6:
          this.saleTypeText = 'Member Shop'
          break
      }
      this.openSale()
    },
    openSale() {
      const header = {
        headers: {
          'x-access-token': this.$store.state.accessToken
        }
      }
      api.openSale(
        header,
        result => {
          console.log(result)
          this.$store.state.txn_id = result.txn_id
          this.$store.state.sale_info = result.info
          this.deleyTime()
        },
        error => {
          console.log(error)
        }
      )
    },
    checkAmount() {
      if (this.$store.state.AmountPayment == this.$store.state.total && this.$store.state.memberProfile != null) {
        clearInterval(this.t)
        this.$socket.sendObj({
          command: 'receive_close'
        })
        this.$socket.sendObj({
          command: 'edc_cancel'
        })
        console.log('memberProfile: ',this.$store.state.memberProfile)
        if (this.$store.state.memberProfile.phone_number.substring(0, 3) == "+66") {
          var str = this.$store.state.memberProfile.phone_number
          var cutBack = str.substring(3, 12);
          var phone_number = "0"+cutBack
        }else{
          var phone_number = this.$store.state.memberProfile.phone_number
        }
        console.log("phone_number:",phone_number)
        this.$store.state.IDWallet = phone_number
        $('#Refurd').modal('hide')
        switch (this.$store.state.PaymentType) {
            case 1: this.$router.push('/processcash')
            break
            case 2: this.$router.push('/processcredit')
            break
            case 3: this.$router.push('/processpromptpay')
            break
            case 4: this.$router.push('/processwallet')
            break
        }
      } else {
        if (this.$store.state.AmountPayment == this.$store.state.total && this.$store.state.SaleID != 1) {
          clearInterval(this.t)
          this.$socket.sendObj({
            command: 'receive_close'
          })
          this.$socket.sendObj({
            command: 'edc_cancel'
          })
          this.$store.state.IDWallet = '0894297335'
          $('#Refurd').modal('hide')
          switch (this.$store.state.PaymentType) {
              case 1: this.$router.push('/processcash')
              break
              case 2: this.$router.push('/processcredit')
              break
              case 3: this.$router.push('/processpromptpay')
              break
              case 4: this.$router.push('/processwallet')
              break
          }
          return
        }
        // if(this.$store.state.PaymentType == 2){
        //   clearInterval(this.t)
        //   this.$store.commit('clearPulling')
        //   this.$store.state.AmountPayment = this.$store.state.total
        //   this.$socket.sendObj({
        //     command: 'receive_close'
        //   })
        //   $('#Refurd').modal('show')
        // }
        if(this.$store.state.PaymentType == 3 || this.$store.state.PaymentType == 4 || this.$store.state.PaymentType == 2 && this.$store.state.SaleID != 1){
          clearInterval(this.t)
          this.$store.commit('clearPulling')
          // this.$store.state.AmountPayment = this.$store.state.total
          this.$socket.sendObj({
            command: 'receive_close'
          })
          this.$socket.sendObj({
            command: 'edc_cancel'
          })
          if(this.$store.state.memberProfile != null){
            console.log('memberProfile: ',this.$store.state.memberProfile)
            if (this.$store.state.memberProfile.phone_number.substring(0, 3) == "+66") {
              var str = this.$store.state.memberProfile.phone_number
              var cutBack = str.substring(3, 12);
              var phone_number = "0"+cutBack
            }else{
              var phone_number = this.$store.state.memberProfile.phone_number
            }
            console.log("phone_number:",phone_number)
            this.$store.state.IDWallet = phone_number
            $('#Refurd').modal('hide')
            this.sp = setInterval(() => {
              if(this.steppull == 1) {
                clearInterval(this.sp)
                this.steppull = 0
                switch (this.$store.state.PaymentType) {
                    case 2: this.$router.push('/processcredit')
                    console.log("processcredit")
                    break
                    case 3: this.$router.push('/processpromptpay')
                    console.log("processpromptpay")
                    break
                    case 4: this.$router.push('/processwallet')
                    console.log("processwallet")
                    break
                }
              }
            })
            return
          }else{
            $('#Refurd').modal('show')
            return
          }
        } else if (this.$store.state.AmountPayment >= this.$store.state.total || this.$store.state.PaymentType == 2) {
          if ( this.$store.state.IDWallet != '' &&  this.$store.state.IDWallet != null){
            clearInterval(this.t)
            this.$socket.sendObj({command: 'receive_close'})
            if (this.$store.state.PaymentType == 2){
              this.$store.state.AmountPayment = this.$store.state.total
              this.$router.push('/processcredit')
            } else {
              this.$socket.sendObj({command: 'edc_cancel'})
              switch (this.$store.state.PaymentType) {
                case 1: this.$router.push('/processcash')
                break
                case 3: this.$router.push('/processpromptpay')
                break
                case 4: this.$router.push('/processwallet')
                break
              }
            }
          } else {
            $('#Refurd').modal({ backdrop: "static" })
            this.$store.commit('clearPulling')
            if ($('#Refurd').is(':visible')) {
              clearInterval(this.t)
              this.$socket.sendObj({
                command: 'receive_close'
              })
              this.$socket.sendObj({
                command: 'edc_cancel'
              })
            }
          }
        }
      }
    },
    websocket_onmessage() {
      this.$socket.onmessage = skResult => {
        this.$store.commit('onMessageWs', JSON.parse(skResult.data))
        var data = JSON.parse(skResult.data)
        console.log(data)
        console.log(data.command)
        console.log(data.result)
        if (data.command == "receive_close") {
          if (data.result == true){
            console.log("printslip")
            this.steppull = 1
          }
        }
      }
    },
  },
  mounted() {
    this.$store.state.isLoading = true
    this.websocket_onmessage();
    this.checkSaleType()
  }
}



// WEBPACK FOOTER //
// ./src/js/type.js